const RoutPath = (props) => {
    return (
        <div className="page-route">
            <a href="#" className="page-route-link">
                الرئيسية
            </a>
            <div className="arrow-svg"></div>
            <a href="#" className="page-route-link">
                بطاقات ببجى
            </a>
            <div className="arrow-svg"></div>
            <span>{props.cardBalance || ""} دولار</span>
        </div>
    );
};

export default RoutPath;
